/* Color strip: pause while someone touches it, so a tap lands on the tile they meant */
(function () {
  document.querySelectorAll('[data-marquee]').forEach(function (m) {
    var t;
    m.addEventListener('touchstart', function () { m.classList.add('is-paused'); clearTimeout(t); }, { passive: true });
    m.addEventListener('touchend', function () { t = setTimeout(function () { m.classList.remove('is-paused'); }, 2500); }, { passive: true });
  });
})();
